import { Facebook, Twitter, Instagram, Youtube, Send, Linkedin } from "lucide-react";
import { useParametres } from "@/hooks/useParametres";

export const RESEAUX_SOCIAUX = [
  { cle: "footer.reseaux.facebook", label: "Facebook", Icon: Facebook },
  { cle: "footer.reseaux.twitter", label: "Twitter/X", Icon: Twitter },
  { cle: "footer.reseaux.instagram", label: "Instagram", Icon: Instagram },
  { cle: "footer.reseaux.linkedin", label: "LinkedIn", Icon: Linkedin },
  { cle: "footer.reseaux.youtube", label: "YouTube", Icon: Youtube },
  { cle: "footer.reseaux.whatsapp", label: "WhatsApp", Icon: Send },
];

/** Icônes des réseaux sociaux configurés dans les paramètres du site (admin),
 * réutilisées dans le header et le footer. N'affiche que ceux renseignés. */
export function SocialLinks({ className = "" }: { className?: string }) {
  const { data: parametres } = useParametres();
  const reseauxActifs = RESEAUX_SOCIAUX.filter((r) => parametres?.[r.cle]);

  if (reseauxActifs.length === 0) return null;

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      {reseauxActifs.map(({ cle, label, Icon }) => (
        <a
          key={cle}
          href={parametres?.[cle]}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          className="flex h-6 w-6 items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon className="h-3.5 w-3.5" />
        </a>
      ))}
    </div>
  );
}
